import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import { Select } from "@ofqual/portal-components/components/Select";
import { ItemType } from "@ofqual/portal-components/components/types";
import { useState } from "react";
import { RecipientUser } from "../../../domain/RecipientsViewModel";
import { User } from "../../../domain/User";

type AddStaffButtonAndDialogProps = {
  users: RecipientUser[];
  userLookups: (User & ItemType)[];
  onSelect: (value: { id: string; upn: string }) => void;
  disabled: boolean;
};

export const AddStaffButtonAndDialog: React.FC<AddStaffButtonAndDialogProps> = ({
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        color="primary"
        onClick={() => setIsOpen(true)}
        disabled={props.disabled}
        data-test="add-staff-button"
      >
        Add Staff
      </Button>

      {isOpen && <AddUserDialog {...props} onClose={() => setIsOpen(false)} />}
    </>
  );
};

export const AddUserDialog: React.FC<
  AddStaffButtonAndDialogProps & { onClose: () => void }
> = ({ users, userLookups, onClose, onSelect }) => {
  const processedLookupsUsers = userLookups.map((user) => ({
    ...user,
    disabled: users.some((orgUser) => orgUser.id === user.id),
  }));

  const handleSelect = (userId: string) => {
    const user = userLookups.find((user) => user.id === userId);
    if (user) {
      onSelect({ id: String(user.id), upn: user.upn });
    }
    onClose();
  };

  appendEmptyMessageIfEmpty(processedLookupsUsers);

  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Add staff permission - select a user</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12}></Grid>
          <Grid item xs={12}>
            <Select
              label="Select a user"
              onChange={(val) => handleSelect(val.target.value)}
              fullWidth
              datatest="select-user-field"
            >
              {processedLookupsUsers}
            </Select>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button component="button" color="primary" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const appendEmptyMessageIfEmpty = (items: ItemType[]) => {
  if (!items.length) {
    items.push({
      id: "",
      label: "This organisation does not have any user records in the portal",
      disabled: true,
    });
  }
};
